












































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import axios from 'axios'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import { Company, CompanyCollection, CompanyTypeEnum, PriceList, PriceListCollection } from 'serverless-firestore'
import LabeledValue from '@/components/LabeledValue.vue'
import AddVendorModal from '@/components/Onboarding/AddVendorModal.vue'
import EnableVendorModal from '@/components/Onboarding/EnableVendorModal.vue'
import { LocaleService } from "@/services/locale.service"
import { ProductTypeEnum } from 'serverless-firestore/lib/Company/ProductTypeEnum'

@Component({
  components: { LabeledValue, AddVendorModal, EnableVendorModal }
})
export default class VendorList extends Mixins(IconsMixin, AuthMixin) {
  public vendors: Company[] = []
  public displayedVendors: Company[] = []
  public priceLists: PriceList[] = []
  public isLoading: boolean = false
  public selectedVendor: Company = {} as Company
  public selectedPriceListPayload: {
    repName: string,
    phoneNumber: string,
    email: string
    } = {
    repName: '',
    phoneNumber: '',
    email: ''
  }

  public showSetupMessage = false
  public valid: boolean = false
  public error: string = ''
  public loadingVendors = false
  public search = ''
  public items = LocaleService.states('United States')
  public values: string[] = []
  public showListView: boolean = false
  public headers = [
    { text: 'Vendor Name', value: 'name' },
    { text: 'Enabled', value: 'enabled' },
    { text: 'Rep Info', value: 'rep' },
    { text: 'Location', value: 'address.state' }
  ]

  // modal props
  public showAddVendorModal = false
  public showEnableVendorModal = false
  public newVendor: {
    name: string,
    phoneNumber: string,
    email: string} = {
      name: '',
      phoneNumber: '',
      email: ''
    }

  public async mounted() {
    const collection = new CompanyCollection(( await this.$firebase ).firestore())
    this.vendors = collection.watchCompaniesByType(CompanyTypeEnum.VENDOR)

    const pCollection = new PriceListCollection(( await this.$firebase ).firestore())
    this.priceLists = pCollection.watchPriceListsByCompanyId(this.userCompany.id, CompanyTypeEnum.RESTAURANT)

    if(this.userCompany.address && this.userCompany.address.state) {
      this.values = [this.userCompany.address.state]
    }
  }

  @Watch('search')
  public async updateVendorsList(search: string) {
    if (this.isLoading || !search) {
      this.displayedVendors = this.getSortedVendors()
      return
    }

    this.isLoading = true
    const displayableVendors = this.vendors.filter(
      vendor => {
        if(vendor.name) {
          if(!vendor.address || !vendor.address.state) {
            return false
          }

          if(
            vendor.productTypes
            && vendor.productTypes.length === 1
            && vendor.productTypes.includes(ProductTypeEnum.ALCOHOL)
            && this.userCompany
            && this.userCompany.address
            && this.userCompany.address.state
            && this.userCompany.address.state !== vendor.address.state
          ) {
            return false
          }

          if(!this.values || !this.values.length) {
            return vendor.name.toLowerCase().includes(search.toLowerCase())
          }

          return vendor.name.toLowerCase().includes(search.toLowerCase())
            && this.values.includes(vendor.address.state)
        } else {
          return false
        }
      }
    )

    this.displayedVendors = this.sortVendors(displayableVendors)

    this.isLoading = false
  }

  @Watch('values')
  public async updatePayload() {
    this.displayedVendors = this.getSortedVendors()
  }

  @Watch('vendors', {immediate: true})
  @Watch('priceLists')
  public updateDisplayedVendors() {
    this.displayedVendors = this.getSortedVendors()
    const hasEnabledVendors = this.displayedVendors.some(v => this.isEnabled(v))
    this.showSetupMessage = !!(this.displayedVendors.length && !hasEnabledVendors)
  }

  get vendorsWithPriceList() {
    return this.vendors.filter(this.lookupPriceListForVendor)
  }

  private getSortedVendors() {
    const displayableVendors = this.vendors.filter(vendor => {
      if(!vendor.address || !vendor.address.state) {
        return false
      }

      if(
        vendor.productTypes
        && vendor.productTypes.length === 1
        && vendor.productTypes.includes(ProductTypeEnum.ALCOHOL)
        && this.userCompany
        && this.userCompany.address
        && this.userCompany.address.state
        && this.userCompany.address.state !== vendor.address.state
      ) {
        return false
      }

      if(this.search) {
        if(!vendor.name) {
          return false
        }

        if(!this.values || !this.values.length) {
          return vendor.name.toLowerCase().includes(this.search.toLowerCase())
        }

        return vendor.name.toLowerCase().includes(this.search.toLowerCase())
          && this.values.includes(vendor.address.state)
      }

      if(!this.values || !this.values.length) {
        return true
      } else {
        if(!vendor.address || !vendor.address.state) {
          return false
        }

        return this.values.includes(vendor.address.state)
      }
    })

    return this.sortVendors(displayableVendors)
  }

  public addVendor() {
    this.newVendor = {
      name: '',
      phoneNumber: '',
      email: ''
    }
    this.showAddVendorModal = true
  }

  public async handleVendorClick(vendor: Company) {
    this.isEnabled(vendor) ? this.viewVendor(vendor) : this.enableVendor(vendor)
  }


  public async viewVendor(vendor: Company) {
    await this.$router.push({ name: 'vendor-details', params: { id: vendor.id } })
  }

  public lookupPriceListForVendor(vendor: Company) {
    return this.priceLists.find((priceList: PriceList) => priceList.vendorCompanyId === vendor.id && priceList.active)
  }

  public lookupRepPhoneNumberForVendor(vendor: Company) {
    const priceList = this.lookupPriceListForVendor(vendor)

    if(!priceList || !priceList.vendorRepPhoneNumber) {
      return ''
    }

    return `: ${priceList.vendorRepPhoneNumber}`
  }

  public lookupRepNameForVendor(vendor: Company) {
    const priceList = this.lookupPriceListForVendor(vendor)

    if(!priceList || !priceList.vendorRepName) {
      return ''
    }

    return priceList.vendorRepDisplayName
  }

  public lookupRepEmailForVendor(vendor: Company) {
    const priceList = this.lookupPriceListForVendor(vendor)

    if(!priceList || !priceList.vendorRepEmail) {
      return ''
    }

    return priceList.vendorRepEmail
  }

  public enableVendor(vendor: Company) {
    this.selectedVendor = vendor
    this.selectedPriceListPayload = {
      repName: this.lookupRepNameForVendor(vendor),
      phoneNumber: this.lookupRepPhoneNumberForVendor(vendor).slice(2),
      email: this.lookupRepEmailForVendor(vendor)
    }
    this.showEnableVendorModal = true
  }

  public hasPriceList(vendor: Company) {
    return !!this.priceLists.find((priceList: PriceList) => priceList.vendorCompanyId === vendor.id)
  }

  public isEnabled(vendor: Company) {
    return !!this.priceLists.find((priceList: PriceList) => priceList.vendorCompanyId === vendor.id && priceList.active === true)
  }

  public letsGetStarted() {
    this.$router.push({ name: 'home'})
  }

  public async loadVendors() {
    this.showAddVendorModal = false

    this.loadingVendors = true

    // refresh the vendor list
    this.updateVendorsList(this.search)

    this.loadingVendors = false
  }

  private sortVendors(vendors: Company[]) {
    return vendors.sort(
      (a,b) => {
        const aIsEnabled = this.isEnabled(a)
        const bIsEnabled = this.isEnabled(b)
        const aPreferred = a.preferred
        const bPreferred = b.preferred


        if(aIsEnabled === bIsEnabled) {
          if(!aIsEnabled && aPreferred) {
            return -1
          } else if (!bIsEnabled && bPreferred) {
            return 1
          }

          return new Intl.Collator('en', { numeric: true }).compare(
            a.name || '',
            b.name || ''
          )
        }

        if(aIsEnabled) {
          return -1
        } else {
          return 1
        }
      }
    )
  }
}
